import React from 'react';
import './HomePage.css';
import { Element } from 'react-scroll';
import Content from '../Content/Content';
import Welcome from '../Welcome/Welcome';

const HomePage = () => {
  return (
    <div className="homePage">
      <div className="welcome">
        <Welcome />
      </div>
      <div className="content">
        <Element name="scrollableContent">
          <Content />
        </Element>
      </div>
    </div>
  );
};

export default HomePage;
